import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareAuthHeaders } from '../../utils/prepareAuthHeaders';

export const systemApi = createApi({
    reducerPath: 'systemApi',
    keepUnusedDataFor: 1,
    tagTypes: ['ReadOnlyMode'],
    baseQuery: fetchBaseQuery({
        baseUrl: '/System',
        prepareHeaders: prepareAuthHeaders,
    }),
    endpoints: (builder) => ({
        getSemesters: builder.query({
            query: () => ({
                url: `/GetSemesters`,
                method: 'GET'
            }),
        }),
        updateData: builder.mutation({
            query: ({ data }) => ({
                url: `/UpdateData`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['Post'],
        }),
        getAcademicYearReadiness: builder.query({
            query: () => ({
                url: `/AcademicYearReadiness`,
                method: 'GET'
            }),
        }),
        updateSchedule: builder.mutation({
            query: ({ data }) => ({
                url: `/UpdateSchedule`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['Post'],
        }),
        getSystemParameters: builder.query({
            query: () => ({
                url: `/GetSystemParameters`,
                method: 'GET'
            }),
        }),
        setSystemParameter: builder.mutation({
            query: ({ data }) => ({
                url: `/SetSystemParameter`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['Post'],
        }),
        getReadOnlyMode: builder.query({
            query: () => ({
                url: `/ReadOnlyMode`,
                method: 'GET'
            }),
            providesTags: ['ReadOnlyMode'],
        }),
        setReadOnlyMode: builder.mutation({
            query: ({startsAt}) => ({
                url: `/ReadOnlyMode`,
                method: 'POST',
                body: {startsAt}
            }),
            invalidatesTags: ['ReadOnlyMode'],
        }),
    }),
});

export const {
    useGetSemestersQuery,
    useUpdateDataMutation,
    useGetAcademicYearReadinessQuery,
    useUpdateScheduleMutation,
    useGetSystemParametersQuery,
    useSetSystemParameterMutation,
    useGetReadOnlyModeQuery,
    useSetReadOnlyModeMutation
} = systemApi;
